import { findSelectedLocation, findSelectedLocationId } from '../selectors/bookingLocation';
import * as API from '../utilities/api';
import { goToRoute, tryNavigateTo } from './navigation';
import { AppStep } from '../reducers/navigation';
import { isModal } from '../routesMap';
import { trySelectLanguage } from './language';

export const FETCH_LOCATIONS = 'FETCH_LOCATIONS';
export const RECEIVE_LOCATIONS = 'RECEIVE_LOCATIONS';
export const SELECT_CITY = 'SELECT_CITY';
export const SELECT_COUNTRY = 'SELECT_COUNTRY';
export const SELECT_FACILITY = 'SELECT_FACILITY';
export const SELECT_LOCATION = 'SELECT_LOCATION';
export const SELECT_LOCATION_ID = 'SELECT_LOCATION_ID';
export const SELECT_PROVINCE_STATE = 'SELECT_PROVINCE_STATE';
export const LOCATION_STEP_BACK = 'LOCATION_STEP_BACK';
export const LOCATION_STEP_FORWARD = 'LOCATION_STEP_FORWARD';
export const GO_DIRECT = 'GO_DIRECT';
export const SET_USED_BOOKING_LOCAL_STORAGE = 'SET_USED_BOOKING_LOCAL_STORAGE';
export const DISABLE_USED_BOOKING_LOCAL_STORAGE = 'DISABLE_USED_BOOKING_LOCAL_STORAGE'

// overwrite: boolean
export function fetchLocations(overwrite) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      if (state.bookingLocation.locationsData.length === 0 || overwrite) {
        API.getLocations()
          .then(result => {
            dispatch(receiveLocations(result));
            const newState = getState();    // Get the updated state. Since the old state could be outdated prior to this check.
            if (newState.bookingLocation.selectedLocationId && newState.bookingLocation.selectedLocation === null) {
              dispatch(trySelectLocation(newState.bookingLocation.selectedLocationId));
            }
            resolve();
          })
          .catch(error => {
            console.error('Failed to get locations info: ' + error);
            reject(error);
          });
      }
      else {
        resolve();
      }
    });
  };
}

export function receiveLocations(locations) {
  return {
    type: RECEIVE_LOCATIONS,
    locations
  };
}

export function trySelectCity(city) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      selectCityAsync(dispatch, city).then(() => {
        // check if city is unique and if thing needs to progress
        const state = getState();
        if (state.bookingLocation.selectedCityUnique) {
          // find the location
          const foundLocation = findSelectedLocation(state.bookingLocation);
          if (foundLocation) {
            selectLocationAsync(dispatch, foundLocation).then(() => {
              dispatch(selectFacility(foundLocation.displayName));
              // go forward
              if (!isModal) dispatch(goToRoute(AppStep.Date));
              else dispatch(tryNavigateTo(AppStep.Date));
            });
          }
          else {
            reject('No selected location found');
          }
        }
        else {
          dispatch(selectCity(city));
          dispatch(stepForward());
        }
      });
      resolve();
    });
  };
}

export function trySelectLocation(LocationId) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      // Okay. We passed in a location ID we want to inject. Now what?
      // We need a list of location to update tho. hmmm.
      const state = getState();

      const foundLocation = findSelectedLocationId(state.bookingLocation);

      // if found! WE MOVE OdN!!!!!
      if (LocationId && foundLocation) {
        selectLocationAsync(dispatch, foundLocation).then(() => {
          dispatch(selectCountry(foundLocation.country));
          dispatch(selectProvinceState(foundLocation.provinceState));
          dispatch(selectCity(foundLocation.city));
          dispatch(selectFacility(foundLocation.displayName));
          // go forward
          dispatch(goDirect(true));
          if (isModal) dispatch(tryNavigateTo(AppStep.Date));
        });
      }
      resolve();
    });
  };
}

export function goDirect(toggle) {
  return {
    type: GO_DIRECT,
    toggle
  };
}

export function selectLocationId(locationId) {
  return {
    type: SELECT_LOCATION_ID,
    locationId
  };
}

export function selectCity(city) {
  return {
    type: SELECT_CITY,
    city
  };
}
export function selectCityAsync(dispatch, city) {
  dispatch(selectCity(city));
  return Promise.resolve();
}

export function selectCountry(country) {
  return {
    type: SELECT_COUNTRY,
    country
  };
}

export function trySelectFacility(facility) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      selectFacilityAsync(dispatch, facility).then(() => {
        // check if city is uniqeue and if thing needs to progress
        const state = getState();
        const location = findSelectedLocation(state.bookingLocation);
        if (location) {
          selectLocationAsync(dispatch, location).then(() => {
            // go forward 
            if (!isModal) dispatch(goToRoute(AppStep.Date));
            else dispatch(tryNavigateTo(AppStep.Date));
          });
        }
        else {
          reject('No selected location found');
        }
      });
      resolve();
    });
  };
}

export function selectFacility(facility) {
  return {
    type: SELECT_FACILITY,
    facility
  };
}
export function selectFacilityAsync(dispatch, facility) {
  dispatch(selectFacility(facility));
  return Promise.resolve();
}

export function selectLocation(location) {
  return {
    type: SELECT_LOCATION,
    location
  };
}
export function selectLocationAsync(dispatch, location) {
  dispatch(selectLocation(location));
  dispatch(trySelectLanguage((location.language_id > 0) ? location.language_id : 1));
  return Promise.resolve();
}

export function selectProvinceState(provinceState) {
  return {
    type: SELECT_PROVINCE_STATE,
    provinceState
  };
}

export function stepBack() {
  return {
    type: LOCATION_STEP_BACK
  };
}

export function stepForward() {
  return {
    type: LOCATION_STEP_FORWARD
  };
}

export function setUsedBookingLocalStorage() {
  var usedBookingLocalStorage = true;
  return {
    type: SET_USED_BOOKING_LOCAL_STORAGE,
    usedBookingLocalStorage
  }
}

export function disableUsedBookingLocalStorage() {
  var usedBookingLocalStorage = false;
  return {
    type: DISABLE_USED_BOOKING_LOCAL_STORAGE,
    usedBookingLocalStorage
  }
}
